export const ADD_ITEM_WISHLIST = "ADD_ITEM_WISHLIST";
export const MOVE_ITEM_FROM_WISHLIST = "MOVE_ITEM_FROM_WISHLIST";
